var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return !_vm.item.hidden
    ? _c(
        "div",
        [
          _vm.hasOneShowingChild(_vm.item.children, _vm.item)
            ? [
                _c(
                  "app-link",
                  { attrs: { to: _vm.item.url || "" } },
                  [
                    _c(
                      "el-menu-item",
                      {
                        class: { "submenu-title-noDropdown": !_vm.isNest },
                        attrs: { index: _vm.item.url },
                        on: {
                          click: function ($event) {
                            return _vm.onClick(_vm.item)
                          },
                        },
                      },
                      [
                        _c(
                          "span",
                          { staticClass: "svg-container" },
                          [_c("svg-icon", { attrs: { "icon-class": "file" } })],
                          1
                        ),
                        _c("item", {
                          attrs: { icon: _vm.item.icon, title: _vm.item.name },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            : _c(
                "el-submenu",
                {
                  ref: "subMenu",
                  attrs: { index: _vm.item.code, "popper-append-to-body": "" },
                },
                [
                  _c(
                    "template",
                    { slot: "title" },
                    [
                      _c(
                        "span",
                        { staticClass: "svg-container" },
                        [_c("svg-icon", { attrs: { "icon-class": "folder" } })],
                        1
                      ),
                      _c("item", {
                        attrs: { icon: _vm.item.icon, title: _vm.item.name },
                      }),
                    ],
                    1
                  ),
                  _vm._l(_vm.item.children, function (child) {
                    return _c("sidebar-item", {
                      key: child.code,
                      staticClass: "nest-menu",
                      attrs: {
                        "is-nest": true,
                        item: child,
                        "base-path": child.url,
                      },
                    })
                  }),
                ],
                2
              ),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }